export interface StatementItemConstructor {
  id: number
  creditcardId: number
  date: string // "YYYY-MM-DD"
  description: string
  amount: string // decimal string, e.g. "250.00"
  duplicateOf: Nullable<number>
  matchId: Nullable<number> // from match — non-null once matched
}

export class StatementItem {
  readonly id: number
  readonly creditcardId: number
  readonly date: string
  readonly description: string
  readonly amount: string
  readonly duplicateOf: Nullable<number>
  readonly matchId: Nullable<number>

  constructor(data: StatementItemConstructor) {
    this.id = data.id
    this.creditcardId = data.creditcardId
    this.date = data.date
    this.description = data.description
    this.amount = data.amount
    this.duplicateOf = data.duplicateOf
    this.matchId = data.matchId
  }

  // Matched rows hide the duplicate/remove overflow (BHV-042)
  get isMatched(): boolean {
    return this.matchId !== null
  }

  // Selection variance math (BHV-031)
  get amountValue(): number {
    return parseFloat(this.amount)
  }
}
